// src/routes/dashboard/components/KpiRow.tsx
import React from 'react';
import { SimpleGrid } from '@mantine/core';
import { IconInbox, IconAlertTriangle, IconSparkles, IconCircleCheck } from '@tabler/icons-react';
import { HomeKpis } from '../../../types/api';
import { KpiCard } from './KpiCard';
import { DeltaBadge } from './DeltaBadge';

interface KpiRowProps {
  kpis: HomeKpis;
  onOverdueClick?: () => void;
}

export function KpiRow({ kpis, onOverdueClick }: KpiRowProps) {
  const periodRangeLabel = formatPreviousPeriodRange(kpis.previousPeriodStartUtc, kpis.previousPeriodEndUtc);

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="lg">
      <KpiCard title="Aperte" value={kpis.openCount} icon={IconInbox} color="blue" />

      <KpiCard
        title="In ritardo"
        value={kpis.overdueCount}
        icon={IconAlertTriangle}
        color="red"
        highlight={kpis.overdueCount > 0}
        onClick={kpis.overdueCount > 0 ? onOverdueClick : undefined}
      />

      <KpiCard
        title="Nuove questo mese"
        value={kpis.createdMonthToDate}
        icon={IconSparkles}
        color="violet"
        rightSection={
          <DeltaBadge
            current={kpis.createdMonthToDate}
            previous={kpis.createdPreviousPeriod}
            tooltipRange={periodRangeLabel}
          />
        }
      />

      <KpiCard
        title="Completate questo mese"
        value={kpis.completedMonthToDate}
        icon={IconCircleCheck}
        color="teal"
        rightSection={
          <DeltaBadge
            current={kpis.completedMonthToDate}
            previous={kpis.completedPreviousPeriod}
            tooltipRange={periodRangeLabel}
          />
        }
      />
    </SimpleGrid>
  );
}

function formatPreviousPeriodRange(startIso: string, endIso: string): string | undefined {
  if (!startIso || !endIso) return undefined;
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return undefined;

  const fmt = (d: Date) => d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
  return `${fmt(start)} – ${fmt(end)}`;
}
